import React from "react";
import { useResume } from "../../data/dataCtx";

export const About = ()=> {
   const resume = useResume();
   return ( <section class="bg-light py-5">
   <div class="container px-5">
       <div class="row gx-5 justify-content-center">
           <div class="col-xxl-8">
               <div class="text-center my-5">
                   <h2 class="display-5 fw-bolder"><span class="text-gradient d-inline">About Me</span></h2>
                   <p class="lead fw-light mb-4">My name is <b>{resume.main?.name}</b> and I help brands grow.</p>
                   <p class="text-muted">{resume.main?.description}</p>
                   <div class="d-flex justify-content-center fs-2 gap-4">
                       {resume.main?.social.map(({url,className},i)=>{
                          return <a target="__blank" key={i} class="text-gradient" href={url}><i className={className}></i></a>
                       })}
                   </div>
               </div>
           </div>
       </div>
   </div>
</section>)
}
